import chatService from './firebaseChatService';

class TypingIndicator {

  isCurrentUserTyping;

  setTypingState(isTyping) {

    this.isCurrentUserTyping = isTyping;
    chatService.updatePresence({
      typing: this.isCurrentUserTyping
    });
  }

  startTyping() {
    this.setTypingState(true);
  }

  stopTyping() {
    this.setTypingState(false);
  }
}

export default new TypingIndicator();



// WEBPACK FOOTER //
// ./chat-app/services/typingIndicator.js